import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useAccount } from '@/apps/adok/entities/account'

import { useLowBalanceDismissal } from './dismissal'

const BALANCE_SUMMARY_ROUTE_NAME = 'balance-summary'

export function useLowBalanceReminder() {
  const route = useRoute()
  const { hasLowBalance, awaitsInitialPayment } = useAccount()
  const { isDismissedToday, dismissToday } = useLowBalanceDismissal()

  // A `ref` and not a modal route: the reminder is raised by the account's state over
  // whatever page is open, so it has no URL of its own.
  const visible = ref(false)

  watch(
    () => route.path,
    () => {
      if (route.name === BALANCE_SUMMARY_ROUTE_NAME) {
        visible.value = hasLowBalance.value || awaitsInitialPayment.value
      } else if (!isDismissedToday()) {
        visible.value = hasLowBalance.value && !awaitsInitialPayment.value
      }
    },
    { immediate: true }
  )

  function close() {
    visible.value = false
    dismissToday()
  }

  return { visible, close }
}
